export const dayOptions = [
  { value: '0', text: 'Sunday', key: 0 },
  { value: '1', text: 'Monday', key: 1 },
  { value: '2', text: 'Tuesday', key: 2 },
  { value: '3', text: 'Wednesday', key: 3 },
  { value: '4', text: 'Thursday', key: 4 },
  { value: '5', text: 'Friday', key: 5 },
  { value: '6', text: 'Saturday', key: 6 },
];

export const hours = [
  { key: 1, text: '01', value: 1 },
  { key: 2, text: '02', value: 2 },
  { key: 3, text: '03', value: 3 },
  { key: 4, text: '04', value: 4 },
  { key: 5, text: '05', value: 5 },
  { key: 6, text: '06', value: 6 },
  { key: 7, text: '07', value: 7 },
  { key: 8, text: '08', value: 8 },
  { key: 9, text: '09', value: 9 },
  { key: 10, text: '10', value: 10 },
  { key: 11, text: '11', value: 11 },
  { key: 12, text: '12', value: 12 },
];

export const minutes = [
  { key: 0, text: '00', value: 0 },
  { key: 15, text: '15', value: 15 },
  { key: 30, text: '30', value: 30 },
  { key: 45, text: '45', value: 45 },
];

export const amOrPm = [
  { key: 0, text: 'AM', value: 'AM' },
  { key: 1, text: 'PM', value: 'PM' },
];

export const dateOptions = [
  { value: 0, label: 'Today' },
  { value: 1, label: 'Other Date' },
];



// WEBPACK FOOTER //
// ./src/pages/newyorksirsexport/constants/sirsConstants.js